import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import MultipleMembersViewer from '../../../../../../../membersSystems/MultipleMembersViewer'
import CustomCircularProgress from '../../../../../../../smallComponents/CustomCircularProgress'
import TitleHeader from '../../../../../../../smallComponents/Header'
import { AuthContext } from '../../../../../../../../context/AuthContext'
import { toast } from 'react-toastify'
import NotificationCreator from '../../../../../../../notificationsSystem/NotificationCreator'
import i18next from 'i18next'

const GlobalInquiryContributors = ({ DCGProps, globalInquiry }) => {
  const [contributors, setContributors] = useState([])
  const { socket } = DCGProps
  const [isLoading, setIsLoading] = useState(true)
  const { user } = useContext(AuthContext)
  useEffect(() => {
    const fetchContributors = async () => {
      setIsLoading(true)
      try {
        const res = await axios.get(
          `/globalInquiries/contributors/${globalInquiry?._id}`
        )
        setContributors(res.data.contributors)
      } catch (error) {
        console.log(error)
      }
      setIsLoading(false)
    }
    fetchContributors()
  }, [globalInquiry?._id])
  const modContributors = contributors?.map((cont) => ({
    ...cont,
    name: cont.firstName + ' ' + cont.lastName,
    id: cont._id,
    image: cont.profilePicture,
    hashTagType: 'userContributor',
  }))
  const { t } = useTranslation()
  const lang = i18next.language
  const rtl = lang === 'ar'
  const [clicked, setClicked] = useState(false)
  const modelProps = {
    buttonsArray:
      user?._id === globalInquiry?.userId
        ? [
            {
              title: rtl ? 'حذف' : 'Remove',
              disabled: clicked,
              funs: async (member) => {
                setClicked(true)
                const res = await axios.patch(
                  `/globalInquiries/removeContributor/${globalInquiry?._id}`,
                  {
                    contributorId: member?._id,
                  }
                )
                const channel = res.data.channel
                // removing the elements
                if (channel) {
                  await axios.patch(`/channels/${channel?._id}`, {
                    elements: channel?.elements?.filter(
                      (e) => !res.data.elements?.includes(e?.id)
                    ),
                  })
                }
                socket.current.emit('addNotifUser', member?._id)
                NotificationCreator({
                  associativity: 'global',
                  relation: 'globalReviewer',
                  conditionIndex: 1,
                  accompaniedData: {
                    elements: [
                      {
                        hashTagType: globalInquiry?.hashTagType,
                        id: globalInquiry?._id || globalInquiry?.id,
                        title: globalInquiry?.Title || globalInquiry?.title,
                      },
                      {
                        id: channel._id,
                        hashTagType: channel.hashTagType,
                        title: channel?.Title || channel?.title,
                      },
                    ],
                  },
                  category: 'contributors',
                  userId: member?._id,
                  currentUser: user,
                  socket,
                })
                toast.warning(
                  rtl
                    ? 'تم حذف المشارك، قم بإعادة الدخول'
                    : 'Contributor has been removed successfully, please, reopen the global inquiry'
                )
              },
            },
          ]
        : [],
  }
  return (
    <section>
      <TitleHeader headerText={t('Contributors')} />
      {isLoading ? (
        <CustomCircularProgress />
      ) : (
        <MultipleMembersViewer
          modelProps={modelProps}
          cards={modContributors}
          windowType='userContributor'
          DCGProps={DCGProps}
          emptySentence={rtl ? 'مساهمين' : 'contributors'}
        />
      )}
    </section>
  )
}

export default GlobalInquiryContributors
